// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/" + "inventariere" + "." + "f362a718" + ".css"; };